// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";

type BannerBodyProps = {
    children: string;
};

const bodyCss = css`
    margin: 0;

    font-size: ${token("space.150")};
    line-height: ${token("space.250")};
`;

const BannerBody = ({ children }: BannerBodyProps) => {
    return <p css={bodyCss}>{children}</p>;
};
export default BannerBody;
